import * as React from "react"
import * as SwitchPrimitives from "@radix-ui/react-switch"

import { cn } from "@/lib/utils"

/**
 * Hoi Buur switch.
 *
 * - Off: solid medium gray track (slate-300) so it stays visible on white surfaces.
 * - On: brand coral (#FF9980).
 * - White thumb with a soft shadow for a tactile feel on mobile.
 * - Pill shape (rounded-full) is intentionally kept here even though brand
 *   guidelines prefer 0px radii elsewhere — toggle-pill is a universal UX pattern
 *   and squared toggles read as "broken".
 */
const Switch = React.forwardRef(({ className, ...props }, ref) => (
  <SwitchPrimitives.Root
    className={cn(
      "peer inline-flex h-6 w-11 shrink-0 cursor-pointer items-center rounded-full border-2 border-transparent transition-colors",
      "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-[#FF9980]/60 focus-visible:ring-offset-white",
      "disabled:cursor-not-allowed disabled:opacity-50",
      "data-[state=unchecked]:bg-slate-300 data-[state=checked]:bg-[#FF9980]",
      className
    )}
    {...props}
    ref={ref}>
    <SwitchPrimitives.Thumb
      className={cn(
        "pointer-events-none block h-5 w-5 rounded-full bg-white shadow-md ring-0 transition-transform",
        "data-[state=checked]:translate-x-5 data-[state=unchecked]:translate-x-0"
      )} />
  </SwitchPrimitives.Root>
))
Switch.displayName = SwitchPrimitives.Root.displayName

export { Switch }
